<div class="v2">
  <div class="top">
    <div class="title-area">
      <div class="text">
        <div class="icon">
          <svg-helper svgName="circle_user"></svg-helper>
        </div>
        <div class="title">Welcome, {{ user?.FullName }}!</div>
        <div class="sub-title">
          <div class="item">{{ user?.ClientName }}</div>
        </div>
      </div>
      <notification-bell (hasJobsThatNeedAttention)="hasJobsThatNeedAttention = true"></notification-bell>
    </div>
  </div>
  <div class="bottom">
    @if (initInProgress) {
    <div class="loading-bars">
      <div></div>
      <div></div>
      <div></div>
    </div>
    }
    @if (!initInProgress) {
    <div class="fadeIn">
      <div class="row">
        <div id="quick-links" class="form-box col-xs-8 col-lg-6">
          <div class="box-header transparent">Quick Links</div>
          @if (quickLinks.length) {
          <div class="flex-column" id="dynamic-quick-links">
            <div class="quick-link">
              <button class="btn link-to-new-order" [routerLink]="'/orders/product-list'">
                <div class="icon">
                  <svg-helper svgName="ordering_new"></svg-helper>
                </div>
                <div class="label">New Order</div>
              </button>
            </div>

            @if (showOnboardingLink) {
            <div class="quick-link">
              <button class="btn standard-positive" [routerLink]="'/onboarding'">
                <div class="icon">
                  <svg-helper svgName="user_handshake"></svg-helper>
                </div>
                <div class="label">Onboarding</div>
              </button>
            </div>
            }

            @for (quicklink of quickLinks; track quicklink) {
            <div class="quick-link">
              @if (quicklink.urlType === 'internal') {
              <button class="btn standard-positive" [routerLink]="quicklink.route.Url">
                @if (quicklink.svgContent) {
                <div class="icon" [innerHTML]="quicklink.svgContent | safeHtml"></div>
                }
                <div class="label">{{quicklink.label}}</div>
              </button>
              }
              @if (quicklink.urlType === 'external') {
              <div class="btn standard-positive external-link">
                @if (quicklink.svgContent) {
                <div class="icon" [innerHTML]="quicklink.svgContent | safeHtml"></div>
                }
                <div class="label">{{quicklink.label}}</div>
                <a [href]="quicklink.url" target="_blank"></a>
              </div>
              }
            </div>
            }
          </div>
          }
          @if (quickLinks.length === 0) {
          <button class="btn link-to-new-order" [routerLink]="'/orders/product-list'">
            <div class="icon">
              <svg-helper svgName="ordering_new"></svg-helper>
            </div>
            <div class="label">New Order</div>
          </button>

          @if (showOnboardingLink) {
          <button class="btn standard-positive" [routerLink]="'/onboarding'">
            <div class="icon">
              <svg-helper svgName="user_handshake"></svg-helper>
            </div>
            <div class="label">Onboarding</div>
          </button>
          }
          @if (hasOrdersAccess) {
          <button class="btn standard-positive" [class.alert]="hasJobsThatNeedAttention" [routerLink]="'/orders/history/jobs/in-production'">
            <div class="icon">
              <svg-helper svgName="history_clock"></svg-helper>
            </div>
            <div class="label">In-Production Jobs</div>
          </button>
          }
          @if (hasLinkGeneratorAccess) {
          <button class="btn standard-positive" [routerLink]="'/tools/link-generator'">
            <div class="icon">
              <svg-helper svgName="link_generator"></svg-helper>
            </div>
            <div class="label">Link Generator</div>
          </button>
          }
          <div class="btn standard-positive external-link">
            <div class="icon">
              <svg-helper svgName="ftp"></svg-helper>
            </div>
            <div class="label">Access MediaLab FTP</div>
            <a href="https://ftp.medialabinc.com/WebInterface/login.html?u={{user?.FTPUsername}}&p={{user?.FTPPassCipher}}" target="_blank"></a>
          </div>
          <div class="btn standard-positive external-link">
            <div class="icon">
              <svg-helper svgName="medialab_logo"></svg-helper>
            </div>
            <div class="label">MediaLab Homepage</div>
            <a href="https://www.medialab3dsolutions.com/" target="_blank"></a>
          </div>
          <div class="btn standard-positive external-link">
            <div class="icon">
              <svg-helper svgName="medialab_logo"></svg-helper>
            </div>
            <div class="label">About Our Products</div>
            <a href="https://www.medialab3dsolutions.com/case-studies/" target="_blank"></a>
          </div>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-xs-6 col-lg-12">
          <div class="form-box bordered">
            <div class="box-header">Check out our portfolio!</div>
            <div class="box-content light no-padding">
              <iframe id="portfolio-iframe" src="https://www.medialab3dsolutions.com/salesportfolio/converge/"></iframe>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-6 col-lg-4">
          <div id="submit-help" class="form-box bordered">
            <div class="box-header">Contact Support</div>
            <div class="box-content light no-padding">
              <iframe src="https://form.smartsuite.com/srillxfa/oPtnpW0kpC?header=false" width="100%" height="600px" style="border: none;"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>